<template>
  <div id="home">
    <!-- 视频列表 -->
    <div class="content">
      
      <div class="lists">
        <router-link
          v-for="(video, index) in videoList"
          :key="index"
          :to="{ path: 'video/' + video.id }"
        >
          <template>
            <div class="pi">
              <div class="list">
                <div class="poster">
                  <van-image height="100%" lazy-load :src="video.cover" />
                </div>
                <div class="info">
                  <div class="title">{{ video.title }}</div>
                  <div class="views-option">
                    <div class="views">
                      <img src="https://i.tmuyun.com/webpic/W0202306/W020230616/W020230616418872972511.png" />
                      <span>{{ video.playbackNumber }}</span>
                    </div>
                    <div class="option">
                      <van-tag v-if="video.hasWatched != 1" plain color="#bbbbbb"
                        >未观看</van-tag
                      >
                      <van-tag v-if="video.hasWatched == 1" color="#ffea00" plain
                        >已观看</van-tag
                      >
                    </div>
                  </div>
                </div>
                <!-- <div class="jie">
              <img src="https://oss.wlxww.com/fanzha/jie.png" alt="" />
            </div> -->
              </div>
            </div>
          </template>
        </router-link>
      </div>
    </div>

    <!-- 登记start -->
    <van-overlay :show="showSignModal" class="sign">
      <van-form @submit="doSign" class="sign-form">
        <div class="title">
          “为保障您在活动中的权益，请您务必填写真实的个人信息，【掌上温岭客户端】将对您的信息进行严格保密，请您放心填写！”
        </div>

        
        <van-field
          required
          v-model="username"
          :placeholder="'请输入姓名'"
        />

        <van-field
          required
          readonly
          clickable
          name="picker"
          :value="village"
          :placeholder="'点击选择学校'"
          @click="showSchoolPicker = true"
        />

        <van-field
          required
          v-model="class_"
          :placeholder="'请输入班级'"
        />

        <van-field
          required
          v-model="phone"
          type="number"
          :placeholder="'请输入手机号码'"
        />

        <van-popup v-model="showSchoolPicker" position="bottom">
          <van-picker
            show-toolbar
            :columns="townSchool"
            @confirm="onConfirm"
            @cancel="showSchoolPicker = false"
          />
        </van-popup>

        <div class="sign-btn">
          <van-button
            native-type="submit"
            :disabled="!village || !phone || !username || !class_"
            >
            <img src="https://i.tmuyun.com/webpic/W0202306/W020230630/W020230630782901451174.png" alt="">
            </van-button
          >
        </div>
      </van-form>
    </van-overlay>
    <!-- 登记end -->

    <van-overlay :show="showFirstLoginModal" @click="showFirstLoginModal = false">
      <div class="wrapper">
        <img src="https://i.tmuyun.com/webpic/W0202306/W020230630/W020230630782895667289.png" class="integral-img" alt="">
      </div>
    </van-overlay>

  </div>
</template>

<script>
import Vue from "vue";

import { Lazyload, Dialog, Overlay } from "vant";
import { getVideoList, getSchool, addUser, getFanzhaUserInfo, hasLogin, saveFirstLogin } from "@/api/fanzha";

Vue.use(Lazyload);

export default {
  name: "List",
  data() {
    return {
      themeId: 3,
      username: "",
      class_: "",
      phone: "",
      schoolId: "",
      showSchoolPicker: false,
      townSchool: [],
      showSignModal: false,
      village: "",
      videoList: [],
      hasLogin: false,
      showFirstLoginModal: false
    };
  },
  created() {
    //加载视频列表
    getVideoList({ themeId: this.themeId }).then((res) => {
      if (res.code == 1) {
        this.videoList = res.data;
      }
    });
  },
  mounted() {
    getFanzhaUserInfo({ themeId: this.themeId }).then((res) => {
      if (res.code == 1 && res.data == null) {
        this.showSignModal = true;
      }else{
        hasLogin({theme_id: this.themeId}).then((res) => {
          if(res.code == 1){
            this.hasLogin = res.data;
            if(!this.hasLogin){
              this.loginToday();
            }
          }
        });
      }
    });
    getSchool({theme_id: this.themeId}).then((res) => {
      if (res.code == 1) {
        this.townSchool = res.data;
      }
    });
  },
  methods: {
    onConfirm(value, index) {
      this.village = value[1];
      this.schoolId = this.townSchool[index[0]]['children'][index[1]]['id'];
      this.showSchoolPicker = false;
    },
    loginToday(){
      saveFirstLogin({theme_id: this.themeId}).then((res) => {
        if(res.code == 1){
          this.showFirstLoginModal = true;
          this.hasLogin = true;
        }else if(res.code == 0){
          Toast.error(res.msg);
        }
      })
    },
    doSign() {
      // 用户登记
      var params = {
        class: this.class_,
        username: this.username,
        village: this.village,
        school_id: this.schoolId,
        phone: this.phone,
        themeId: this.themeId,
      };
      // console.log(params);
      addUser(params).then((res) => {
        if (res.code == 1) {
          this.showSignModal = false;
          // Toast.success(res.msg);
          // 调用第一次登录加分
          if(!this.hasLogin){
            this.loginToday();
          }
        } else {
          Dialog.alert({
            message: res.msg,
          });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
a {
  color: #000;
}

.sign {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  .sign-form {
    background-image: url(https://i.tmuyun.com/webpic/W0202306/W020230630/W020230630782898004576.png);
    background-size: 100%;
    background-repeat: no-repeat;
    min-height: 400px;
    width: 70vw;
    padding: 60px 40px 10px 40px;
    border-radius: 10px;
    .title {
      color: #000;
      font-size: 14px;
      margin-bottom: 10px;
    }
  }
  .sign-btn {
    margin-top: 10px;
    text-align: center;
    button {
      background-color: transparent;
      border: 0px;
      padding: 0;
    }
    img {
      width: 70%;
    }
  }
}


.lists {
  margin-top: 10px;
  .pi {
    background-image: url(https://i.tmuyun.com/webpic/W0202306/W020230616/W020230616420067113742.png);
    background-size: 100% 100%;
    padding: 10px 5px;
    margin-bottom: 15px;
    .list {
      position: relative;
      display: inline-flex;
      padding: 10px 0 10px 10px;
      .poster {
        flex: 0 0 40%;
        img {
          width: 100%;
          object-fit: cover;
        }
      }
      .info {
        flex: 1;
        // color: #fff;
        margin-left: 10px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .title {
          color: #fff;
          width: 80%;
          font-size: 14px;
        }
        .views-option {
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 85%;
          .views {
            flex: 0 0 50%;
            line-height: 20px;
            color: #ffcc00;
            img {
              width: 20px;
              vertical-align: text-bottom;
            }
            span {
              margin-left: 5px;
            }
          }
          .option {
            text-align: right;
            padding-right: 10px;
          }
        }
      }
    }
  }
}

.wrapper {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    .integral-img {
      width: 60%;
    }
  }
</style>
